import Service from "../Service";

const resource = "RecruitmentAccess/";

export default {
  permission(usrID, requestID) {
    return Service.post(resource + "permission", null, {
      params: { usrID: usrID, requestID: requestID },
    });
  },
  savePermission(payload, requestID) {
    return Service.post(resource + "savePermission", payload, {
      params: { requestID: requestID },
    });
  },
  assignments(rprID, requestID) {
    return Service.post(resource + "assignments", null, {
      params: { rprID: rprID, requestID: requestID },
    });
  },
  saveAssignments(payload, requestID) {
    return Service.post(resource + "saveAssignments", payload, {
      params: { requestID: requestID },
    });
  },
  assignmentsByUser(usrID, requestID) {
    return Service.post(resource + "assignmentsByUser", null, {
      params: { usrID: usrID, requestID: requestID },
    });
  },
  massiveApprovedRequirements(requestID) {
    return Service.post(resource + "massiveApprovedRequirements", null, {
      params: { requestID: requestID },
    });
  },
  massiveAssignments(reqID, requestID) {
    return Service.post(resource + "massiveAssignments", null, {
      params: { reqID: reqID, requestID: requestID },
    });
  },
  saveMassiveAssignments(payload, requestID) {
    return Service.post(resource + "saveMassiveAssignments", payload, {
      params: { requestID: requestID },
    });
  },
  massiveAssignmentsByUser(usrID, requestID) {
    return Service.post(resource + "massiveAssignmentsByUser", null, {
      params: { usrID: usrID, requestID: requestID },
    });
  },
};